<app-page-title icon="fa-file" title="Relatório analítico de vendas">
  <a href="/#/analytics" class="btn btn-danger" title="Voltar para página anterior">Voltar</a>
</app-page-title>

<div class="app-analytics">
  <div class="row">
    <div class="col-12 col-sm-7">
      <div class="form-group fast-filter">
        <label>Filtros rápidos</label>
        <div class="mb-2">
          <button class="btn btn-primary me-2" *ngFor="let filter of fastFilters"
                  [class.active]="filter.id === fastFilter"
                  (click)="applyFastFilter(filter.id)">{{ filter.text }}</button>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-5">
      <div class="row">
        <div class="form-group col-6">
          <label>&nbsp;</label>
          <mat-form-field>
            <mat-label>De</mat-label>
            <input matInput [matDatepicker]="startDatePicker" [(ngModel)]="startDate" (dateChange)="fastFilter = null">
            <mat-datepicker-toggle matIconSuffix [for]="startDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #startDatePicker></mat-datepicker>
            <small
              class="text text-danger"
              *ngIf="startDate && endDate && startDate > endDate"
            >Período inválido.</small
            >
          </mat-form-field>
        </div>
        <div class="form-group col-6">
          <label>&nbsp;</label>
          <mat-form-field>
            <mat-label>Até</mat-label>
            <input matInput [matDatepicker]="endDatePicker" [(ngModel)]="endDate" (dateChange)="fastFilter = null">
            <mat-datepicker-toggle matIconSuffix [for]="endDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #endDatePicker></mat-datepicker>
            <small
              class="text text-danger"
              *ngIf="startDate && endDate && startDate > endDate"
            >Período inválido.</small
            >
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
  <div class="row mb-2">
    <div class="col-10">
      <label for="integration">Integração</label>
      <select name="integration" id="integration" class="form-control" [(ngModel)]="integrationId"
              *ngIf="integrations$ | async as integrations; else loadingIntegrations"
      >
        <option value="0">Todas</option>
        <option *ngFor="let integration of integrations" [value]="integration.id">
          {{ integration.name }}
        </option>
      </select>
      <ng-template #loadingIntegrations>
        <app-skeleton variant="text" [count]="1" label="Carregando as integrações"></app-skeleton>
      </ng-template>
    </div>

    <div class="col-2">
      <div>&nbsp;</div>
      <button class="btn btn-primary" (click)="applyFilter()">
        <i class="fa fa-search"></i>
      </button>
      <button class="btn btn-secondary ms-2" (click)="clearFilter()">
        <i class="fa fa-trash"></i>
      </button>
    </div>
  </div>

  <app-skeleton *ngIf="loading" variant="card" [count]="3"
    label="Carregando os indicadores de venda" data-testid="sales-loading"></app-skeleton>

  <div class="row" [hidden]="loading">
    <div class="col-12 col-sm-4 my-1">
      <app-analytics-card
        title="Recuperações"
        highlightText="{{ salesIndicator?.sales_amount | numberFormat: 'R$ ' : true }}"
        tooltipText="Refere-se ao valor total recuperado através de ações realizadas para resgatar vendas que inicialmente não foram concluídas. Esse número indica o sucesso em converter clientes que abandonaram o processo de compra."
      >
        <div class="mt-2 badgeds">
          <span class="badge badge-info">{{ salesIndicator?.sales_quantity | number }} venda(s)</span>
          <span class="badge badge-info">{{ salesIndicator?.sales_cpv | numberFormat: 'R$ ' : true }} CPV</span>
          <span class="badge badge-info">{{ salesIndicator?.sales_roas | number }} ROAS</span>
        </div>
      </app-analytics-card>
    </div>
    <div class="col-12 col-sm-4 my-1">
      <app-analytics-card
        title="Recuperações SMSFunnel"
        highlightText="{{ salesIndicator?.sales_amount_smsfunnel | numberFormat: 'R$ ' : true }}"
        tooltipText="Mostra o quanto foi recuperado especificamente utilizando as automações e mensagens da ferramenta SMSFunnel. Permite avaliar a efetividade da plataforma na recuperação de vendas perdidas."
      >
        <div class="mt-2 badgeds">
          <span class="badge badge-info">{{ salesIndicator?.sales_quantity_smsfunnel | number }} venda(s)</span>
          <span class="badge badge-info">{{ salesIndicator?.sales_cpv_smsfunnel | numberFormat: 'R$ ' : true }} CPV</span>
          <span class="badge badge-info">{{ salesIndicator?.sales_roas_smsfunnel | number }} ROAS</span>
        </div>
      </app-analytics-card>
    </div>
    <div class="col-12 col-sm-4 my-1">
      <app-analytics-card
        title="Quantidade SMS Enviados"
        highlightText="{{ salesIndicator?.sent_quantity | number }}"
        tooltipText="Indica quantas mensagens de texto foram enviadas no período analisado. Esse dado ajuda a mensurar o volume de tentativas de comunicação com os leads ou clientes."
      >
        <div class="mt-2 badgeds">
          <span class="badge badge-info">{{ salesIndicator?.total_coast | numberFormat: 'R$ ' : true }} custo</span>
        </div>
      </app-analytics-card>
    </div>
    <div class="col-12 col-sm-4 my-1">
      <app-analytics-card
        title="Pix"
        highlightText="{{ salesIndicator?.total_pix_amount | numberFormat: 'R$ ' : true }}"
        tooltipText="Representa o valor total das vendas que foram concluídas com a forma de pagamento via Pix. Ajuda a entender a preferência dos clientes por esse método."
      >
        <div class="mt-2 badgeds">
          <span class="badge badge-info">{{ salesIndicator?.total_pix_quantity | number }} venda(s)</span>
          <span class="badge badge-info">{{ salesIndicator?.pix_cpv | numberFormat: 'R$ ' : true }} CPV</span>
          <span class="badge badge-info">{{ salesIndicator?.pix_roas | number }} ROAS</span>
        </div>
      </app-analytics-card>
    </div>
    <div class="col-12 col-sm-4 my-1">
      <app-analytics-card
        title="Cartão"
        highlightText="{{ salesIndicator?.total_card_amount | numberFormat: 'R$ ' : true }}"
        tooltipText="Mostra quanto foi faturado através de vendas pagas com cartão de crédito ou débito. É útil para monitorar o desempenho desse meio de pagamento."
      >
        <div class="mt-2 badgeds">
          <span class="badge badge-info">{{ salesIndicator?.total_card_quantity | number }} venda(s)</span>
          <span class="badge badge-info">{{ salesIndicator?.card_cpv | numberFormat: 'R$ ' : true }} CPV</span>
          <span class="badge badge-info">{{ salesIndicator?.card_roas | number }} ROAS</span>
        </div>
      </app-analytics-card>
    </div>
    <div class="col-12 col-sm-4 my-1">
      <app-analytics-card
        title="Boleto"
        highlightText="{{ salesIndicator?.total_billet_amount | numberFormat: 'R$ ' : true }}"
        tooltipText="Indica o valor gerado por vendas realizadas com boletos bancários. Ajuda a compreender a adesão dos clientes a essa modalidade de pagamento."
      >
        <div class="mt-2 badgeds">
          <span class="badge badge-info">{{ salesIndicator?.total_billet_quantity | number }} venda(s)</span>
          <span class="badge badge-info">{{ salesIndicator?.billet_cpv | numberFormat: 'R$ ' : true }} CPV</span>
          <span class="badge badge-info">{{ salesIndicator?.billet_roas | number }} ROAS</span>
        </div>
      </app-analytics-card>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <h3 class="mt-3 mb-2">Progressão de vendas no período</h3>
    </div>
    <div class="col-12 col-sm-8 my-1">
      <div class="card">
        <apx-chart
          *ngIf="salesChartOptions"
          [series]="salesChartOptions.series"
          [chart]="salesChartOptions.chart"
          [title]="salesChartOptions.title"
          [tooltip]="salesChartOptions.tooltip"
          [colors]="salesChartOptions.colors"
          [grid]="salesChartOptions.grid"
          [xaxis]="salesChartOptions.xaxis"
          [dataLabels]="salesChartOptions.dataLabels"
        >
        </apx-chart>
      </div>
    </div>
    <div class="col-12 col-sm-4">
      <app-analytics-card
        title="Total de vendas"
        highlightText="{{ salesIndicator?.sales_quantity }}"
        tooltipText="Exibe o número total de vendas concluídas no período. É uma métrica geral de desempenho e crescimento das vendas da operação."
        autoHeight="false"
      >
      </app-analytics-card>
      <div style="height:10px"></div>
      <app-analytics-card *ngIf="false"
                          title="+Info"
                          tooltipText="Olá mundo!"
                          autoHeight="false"
      >
        <div class="mt-2 badgeds">
          <span class="badge badge-info">1.219x ROAS</span>
          <span class="badge badge-info">R$ 99,12 CPV</span>
        </div>
      </app-analytics-card>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <h3 class="mt-3 mb-2">Origem de vendas (UTMs)</h3>
    </div>
    <div class="col-12 my-1">
      <div class="card">
        <apx-chart
          *ngIf="sourceChartOptions"
          style="width: 100%"
          [series]="sourceChartOptions.series"
          [chart]="sourceChartOptions.chart"
          [title]="sourceChartOptions.title"
          [tooltip]="sourceChartOptions.tooltip"
          [colors]="sourceChartOptions.colors"
          [grid]="sourceChartOptions.grid"
          [xaxis]="sourceChartOptions.xaxis"
          [dataLabels]="sourceChartOptions.dataLabels"
        >
        </apx-chart>
      </div>
    </div>
  </div>
</div>
